module.exports = "pegasus_template/assets/roundrect-twitter.png";